import API from "../../api/axiosInstance";

function personIdFromBooking(b) {
  const p = b.participant_id;
  if (!p) return "";
  return typeof p === "object" && p._id ? String(p._id) : String(p);
}

function competitionIdFromBooking(b, fallback) {
  const c = b.competition_id;
  if (c && typeof c === "object" && c._id) return String(c._id);
  if (c) return String(c);
  return fallback ? String(fallback) : "";
}

export function allocationTypeLabelFromBooking(b) {
  const t = b?.allocation_type;
  if (!t) return "";
  if (t === "private") return "Private";
  if (t === "required" || t === "standard") return "Required";
  return String(t);
}

/** Fire-and-forget cancellation email; failures are logged, never thrown. */
export async function sendCancellationEmailRequest({ cancelledBookings, hotelName, roomType, roomLabel, competitionId }) {
  if (!cancelledBookings?.length) return;
  const keys = [...new Set(cancelledBookings.map((b) => b.la_date_key).filter(Boolean))].sort();
  if (!keys.length) return;
  const participant_id = personIdFromBooking(cancelledBookings[0]);
  if (!participant_id) return;
  const competition_id = competitionIdFromBooking(cancelledBookings[0], competitionId) || undefined;
  const guest_count = Math.max(...cancelledBookings.map((b) => Number(b?.guest_count || 0)));
  const allocation_type = cancelledBookings[0]?.allocation_type || "";
  const allocation_type_label = allocationTypeLabelFromBooking(cancelledBookings[0]);
  try {
    await API.post("/ems/room-bookings/send-cancellation", {
      participant_id,
      checkin_date: keys[0],
      checkout_date: keys[keys.length - 1],
      total_nights: keys.length,
      hotel_name: hotelName || "",
      room_type: roomType || "",
      room_label: roomLabel || "",
      guest_count,
      allocation_type,
      allocation_type_label,
      competition_id,
    });
  } catch (err) {
    console.error("Cancellation email failed:", err);
  }
}
